const PENDING_CART_TOKEN_STORAGE_PREFIX = 'pendingCartToken:'

function getStorageKey(licenseCode: string) {
  return `${PENDING_CART_TOKEN_STORAGE_PREFIX}${licenseCode}`
}

export function setPendingCartToken(licenseCode: string, token: string) {
  localStorage.setItem(getStorageKey(licenseCode), token)
}

export function getPendingCartToken(licenseCode: string): string | null {
  return localStorage.getItem(getStorageKey(licenseCode))
}

export function clearPendingCartToken(licenseCode: string) {
  localStorage.removeItem(getStorageKey(licenseCode))
}
